import { render, staticRenderFns } from "./MarginRoundingRow.vue?vue&type=template&id=48d90fe8&"
import script from "./MarginRoundingRow.vue?vue&type=script&lang=js&"
export * from "./MarginRoundingRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports